  const all_JP_TAbs = new Swiper('.triger-tabs', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      slidesPerGroup: 1, // Number of slides to scroll when clicking Next
      allowTouchMove: false,
      navigation: {
        nextEl: '.swiper-tab-button-next',
        prevEl: '.swiper-tab-button-prev',
      },
    });
